<div>
  <div class="modal in" style="display: block;">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa-duotone fa-triangle-exclamation"></i>
            {{ 'COMMON.idle_timeout_title' | translate }}
          </h5>
        </div>
        <div class="modal-body p-lg">
          <div [innerHTML]="'COMMON.idle_timeout_text' | translate: {remainingSeconds: remainingSeconds}"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary p-x-md" test-id="cancelButton" (click)="logout()">
            {{ 'COMMON.logout_session' | translate }}
          </button>
          <button type="button" class="btn btn-dark p-x-md" test-id="confirmButton" (click)="keepSession()">
            {{ 'COMMON.keep_session' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
